import { fetcher } from '../utils/fetcher';

import type { Programme, ProgrammeBase, ProgrammeCreate, ProgrammeUpdate } from '../types/programme';

export type { Programme, ProgrammeBase, ProgrammeCreate, ProgrammeUpdate };
/** @deprecated `Programme` already carries the rolled-up metrics; kept for existing imports. */
export type ProgrammeReadDetailed = Programme;

const API_URL = '/api/v1/programmes';

export const getProgrammes = async (): Promise<Programme[]> => {
  return await fetcher(`${API_URL}/read`);
};

export const getProgrammeById = async (id: string): Promise<Programme> => {
  return await fetcher(`${API_URL}/read/${id}`);
};

export const createProgramme = async (data: ProgrammeCreate): Promise<ProgrammeBase> => {
  return await fetcher(`${API_URL}/create`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(data),
  });
};

export const updateProgramme = async (id: string, data: ProgrammeUpdate): Promise<ProgrammeBase> => {
  return await fetcher(`${API_URL}/update/${id}`, {
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(data),
  });
};

export const deleteProgramme = async (id: string): Promise<boolean> => {
  return await fetcher(`${API_URL}/delete/${id}`, {
    method: 'DELETE',
  });
};
